import { render, staticRenderFns } from "./Ideas_comment_delete.vue?vue&type=template&id=40ab5d4b"
import script from "./Ideas_comment_delete.vue?vue&type=script&lang=js"
export * from "./Ideas_comment_delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports